import type { IModuleSummary } from '@platform/core/types';
import type { IMappableType } from './IMappableType';
import type { IMappingScope } from './IMappingScope';

/** Основні модулі на початку переліку без `order` (старіший сервер) — як у просторі прототипу: справи, завдання, база знань, CRM. */
const FIRST: readonly string[] = ['case', 'task', 'kb', 'crm'];
const rank = (key: string) => (FIRST.includes(key) ? FIRST.indexOf(key) : FIRST.length);

/**
 * Типи записів, які «Зіставлення» вважає модулями простору (прототип v4: ws.modules), у їх порядку: з `order` каталогу — лише типи з
 * місцем у переліку модулів простору, за ним (зокрема й без записів, як у фільтрі «У:» прототипу); без нього — типи встановлених модулів
 * (основні модулі першими, головний тип модуля першим) без підтаблиць, класифікаторів і прихованих типів. Чиста функція.
 */
export function mappingScopes(modules: readonly IModuleSummary[]): IMappingScope[] {
  const installed = modules.filter((m) => m.installed).map((m, i) => ({ m, i })).sort((a, b) => rank(a.m.key) - rank(b.m.key) || a.i - b.i);
  const all = installed.flatMap(({ m }) => [...m.recordTypes as IMappableType[]].sort((a, b) => Number(b.main) - Number(a.main)).map((r) => ({ r, m })));
  const ordered = all.length > 0 && all.every(({ r }) => r.order === null || typeof r.order === 'number');
  const listed = ordered
    ? all.filter(({ r }) => typeof r.order === 'number').sort((a, b) => (a.r.order as number) - (b.r.order as number))
    : all.filter(({ r }) => !r.subTable && !r.hidden && r.kind !== 'catalogue');
  return listed.map(({ r, m }) => ({ key: r.key, module: m.key, main: r.main, name: r.main ? m.name : r.name }));
}
